var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlpApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#14BF96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 14.625C27.125 14.875 27.5 15.4062 27.5 16C27.5 24 21.5938 28 19.9688 28C18.4062 28 12.5 24.0625 12.5 16C12.5 15.4062 12.8438 14.875 13.4062 14.625L19.4062 12.125C19.5625 12.0625 19.8125 12.0312 20 12.0312C20.1562 12.0312 20.4062 12.0625 20.5625 12.125L26.5625 14.625ZM23 18.25C23 18.0312 22.8125 17.5 22.25 17.5C22.0312 17.5 21.8125 17.5625 21.6562 17.75L19.1875 20.625L18.25 19.7188C18.125 19.5625 17.9375 19.5 17.75 19.5C17.3125 19.5 17 19.8438 17 20.25C17 20.4688 17.0625 20.6562 17.2188 20.7812L18.7188 22.2812C18.8438 22.4062 19.0312 22.5 19.25 22.5C19.3125 22.5 19.5938 22.5 19.8125 22.25L22.8125 18.75C22.9375 18.625 23 18.4375 23 18.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpApproved);
export default __webpack_public_path__ + "static/media/DlpApproved.7f97aea3fd9f458b9c50fff9446ad544.svg";
export { ForwardRef as ReactComponent };